import React from 'react'
import { createRoot } from 'react-dom/client'

import MonDVMap2 from './pages/monitoreoDatosVarsMapa'
import PronosticoMarino from './pages/pronostico-marino/pronosMarino'
import GeoVisualizador from './pages/geo-visualizador/geoVisualizador'
import ResumenAdv from './pages/resumen-adv/ResumenAdv'
import DatosAbiertos from './pages/datos-abiertos/DatosAbiertos'
//import MonitoreoDatosVarsMapa from './pages/monitoreoDatosVarsMapa'
import Highcharts from 'highcharts'
import highchartsOptions from './config/highchartsOptions'

// css
import '@fortawesome/fontawesome-free/css/all.min.css'
import './index.css'
import './scss/react.scss'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'

Highcharts.setOptions(highchartsOptions)

const App = () => {
    const renderPage = () => {
        const hash = window.location.hash.replace('#', '')

        switch (hash) {
            case '/pronostico-marino':
                return <PronosticoMarino />
            case '/portal-agro':
                return <GeoVisualizador />
            case '/mon-datos-vars-v2':
                return <MonDVMap2 />
            case '/resumen-adv':
                return <ResumenAdv />
            case '/datos-abiertos':
                return <DatosAbiertos />
            default:
                return <ResumenAdv />
        }
    }
    return renderPage()
}
const root = createRoot(document.getElementById('root'))
root.render(<App />)
